import {Component} from '@angular/core';
import {
  JeevesInvoiceActionConfigService,
  JeevesInvoiceCardListComponent,
  JeevesInvoiceListConfigService
} from "gung-standard-jeeves";
import {TyloJeevesInvoiceListConfigService} from "../../services/tylo-jeeves-invoice-list-config.service";
import {BackendInterceptor} from "gung-standard";


@Component({
  selector: 'tylo-tylo-jeeves-invoice-card-list',
  templateUrl: './tylo-jeeves-invoice-card-list.component.html',
  styleUrls: ['./tylo-jeeves-invoice-card-list.component.scss'],
})
export class TyloJeevesInvoiceCardListComponent extends JeevesInvoiceCardListComponent {
  public baseUrl = this.backendInterceptor.getBaseUrl();
  constructor(
    configService: JeevesInvoiceActionConfigService,
    private backendInterceptor: BackendInterceptor
  ) {
    super(configService);
  }

  get invoiceId() {
    return this.data.id;
  }


}
